import React, { createContext, use, useMemo, useState } from "react";

interface HoveredMaterialContextType {
  hoveredMaterial: string | null;
  setHoveredMaterial: (material: string | null) => void;
}

const HoveredMaterialContext = createContext<
  HoveredMaterialContextType | undefined
>(undefined);

interface HoveredMaterialProviderProps {
  children: React.ReactNode;
}

export const HoveredMaterialProvider: React.FC<
  HoveredMaterialProviderProps
> = ({ children }) => {
  const [hoveredMaterial, setHoveredMaterial] = useState<string | null>(null);

  const value = useMemo(
    () => ({
      hoveredMaterial,
      setHoveredMaterial,
    }),
    [hoveredMaterial, setHoveredMaterial]
  );

  return (
    <HoveredMaterialContext value={value}>{children}</HoveredMaterialContext>
  );
};

export const useHoveredMaterialContext = () => {
  const context = use(HoveredMaterialContext);
  if (!context) {
    throw new Error(
      "useHoveredMaterialContext must be used within a HoveredMaterialProvider"
    );
  }
  return context;
};
